import { render } from "./SystemError.vue?vue&type=template&id=2a01b8fb"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/SystemError.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a01b8fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a01b8fb', __exports__)) {
    api.reload('2a01b8fb', __exports__)
  }
  
  module.hot.accept("./SystemError.vue?vue&type=template&id=2a01b8fb", () => {
    api.rerender('2a01b8fb', render)
  })

}


export default __exports__